<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <TheTopmenu />
      <div class="container text-start">
        <div class="my-2">
          مدیریت صندلی های همایش:
          <span class="fs-3 m-2">
            {{ productName }}
          </span>
        </div>

        <AddChairs :productId="+productId" @refreshList="reloadList" />

        <ListChairs :productId="+productId" :key="ListIndexKeyForReload" />
      </div>
    </div>
  </div>
</template>
<script>
import TheSidemenu from "../../components/TheSidemenu";
import TheTopmenu from "../../components/TheTopmenu";
import ArefApi from "../../libs/api.js";
import utils from "../../libs/utils.js";
import AddChairs from "./components/AddChairs";
import ListChairs from "./components/ListChairs";


export default {
  name: "Chairs",
  created: function () {
    this.utils = new utils();
    this.arefApi = new ArefApi(this);
    this.getProductName();
  },
  components: {
    TheSidemenu,
    TheTopmenu,
    AddChairs,
    ListChairs
  },
  data() {
    return {
      productId: this.$route.params.productId,
      productName: null,
      ListIndexKeyForReload:0
    };
  },
  methods: {
    async getProductName() {
      try {
        let res = await this.arefApi.getProduct(this.productId);
        this.productName = res.data.name;
      } catch {
        this.productName = "محصول پیدا نشد";
      }
    },
    reloadList(){
        console.log("reloadList");
        this.ListIndexKeyForReload++;
    }
  },
};
</script>